import React, { createContext, useContext, useState, ReactNode } from 'react';
import { CategoryItem } from '../assets/interfaces/customer_interfaces';

interface CatPropsData {
  selectedCategory: CategoryItem | null;
  setSelectedCategory: (cat: CategoryItem | null) => void;
}

const CategoryContext = createContext<CatPropsData | undefined>(undefined);

export const useCategory = () => {
  const context = useContext(CategoryContext);
  if (context === undefined) {
    throw new Error('useCategory must be used within a CategoryProvider');
  }
  return context;
};

interface CategoryProviderProps {
  children: ReactNode;
}

export const CategoryProvider: React.FC<CategoryProviderProps> = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState<CategoryItem | null>(null);

  return (
    <CategoryContext.Provider value={{ selectedCategory, setSelectedCategory }}>
      {children}
    </CategoryContext.Provider>
  );
};
